<template>
  <div class="mb-12">
    <h1 class="text-center">Question Bank Cohorts</h1>
    <router-link
      class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-2 hover:bg-green-900 no-underline rounded-full inline-block"
      to="/question_bank/create-cohort"
    >
      Add Cohort
    </router-link>
    <Table :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import cohortMixin from "@/mixins/cohortMixin"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  mixins: [cohortMixin],
  data() {
    return {
      endpoint: `${siteConfig.siteURL}question_bank/cohorts`,
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "name",
        },
        { header: { textContent: "Id" }, path: "id" },
        {
          header: {
            textContent: "Slug",
          },
          path: "slug",
        },
        {
          header: { textContent: "Tags" },
          path: "cohort_tags.0.cohort_tag_id",
          formatter: this.getCohortTagsHTML,
        },
        {
          header: { textContent: "Created On", sortingParam: "created_on" },
          type: "date",
          path: "created_on",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: {
            textContent: "Option",
          },

          path: "id",
          type: "action",
          actionButtonText: "Edit",
          routePath: "/question_bank/cohorts/:cohortId",
        },
      ],
    }
  },
  created() {
    this.fetchCohortTags()
  },
}
</script>
